<!-- Toolbar -->

<mat-toolbar fxLayout="row" fxLayoutAlign="space-between center">
  <nav fxLayout="row" fxLayoutAlign="space-between center">
    <button app-logo (click)="scrollToTop()"></button>
    <a class="mobile-navbar" test-id="signup" mat-button color="primary" routerLink="/auth/identity">Join us</a>
    <a mat-stroked-button color="primary" href="#demo" id="demo-link">Schedule a demo</a>
    <a test-id="login" mat-button color="primary" routerLink="/auth/connexion">Log in</a>
    <a test-id="signup" mat-button color="primary" routerLink="/auth/identity">Sign up</a>
    <a mat-stroked-button color="primary" routerLink="/auth/identity">
      <mat-icon svgIcon="invitation"></mat-icon>
      <span>First invitation</span>
    </a>
  </nav>
</mat-toolbar>

<main>
  <!-- Bridge between app banner -->

  <ng-content select="app-bridge-banner"></ng-content>

  <!-- Header -->

  <ng-content select="landing-header"></ng-content>

  <!-- Content -->

  <ng-content select="landing-content"></ng-content>

  <!-- Contact -->

  <section class="demo dark-contrast-theme" id="demo">
    <section class="max-width">
      <ng-container *ngIf="landingContactDirective; else contact">
        <ng-content select="landing-contact"></ng-content>
      </ng-container>
      <ng-template #contact>
        <article fxLayout="column" fxLayoutAlign="start center" class="contact-us">
          <h1 class="mat-headline-4">Want to learn more?</h1>
          <h3>Schedule a demo with our team!</h3>
          <p>
            Please fill out the following form and we will get back to you asap.
          </p>
        </article>
        <form fxLayout="column" fxLayoutAlign="start center" [formGroup]="form" (ngSubmit)="sendRequest(form)">
          <article fxLayout="row" fxLayoutAlign="space-between start" fxLayout.lt-md="column" fxLayoutGap="24px">
            <mat-form-field appearance="outline">
              <mat-label>First Name</mat-label>
              <input matInput type="text" placeholder="First Name" formControlName="firstName" required test-id="first-name"/>
              <mat-error *ngIf="form.get('firstName').hasError('required')">
                First Name is <strong>required</strong>
              </mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Last Name</mat-label>
              <input matInput type="text" placeholder="Last Name" formControlName="lastName" required  test-id="last-name"/>
              <mat-error *ngIf="form.get('lastName').hasError('required')">
                Last Name is <strong>required</strong>
              </mat-error>
            </mat-form-field>
          </article>
          <article fxLayout="row" fxLayoutAlign="space-between start" fxLayout.lt-md="column" fxLayoutGap="24px">
            <mat-form-field appearance="outline">
              <mat-label>Company Name</mat-label>
              <input matInput type="text" placeholder="Company Name" formControlName="companyName" required test-id="company"/>
              <mat-error *ngIf="form.get('companyName').hasError('required')">
                Company Name is <strong>required</strong>
              </mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Role</mat-label>
              <mat-select placeholder="Activity" formControlName="role" required test-id="role">
                <ng-container *ngFor="let role of roles">
                  <mat-option [value]="role" [attr.test-id]="'role_' + role">{{ role | roleLabel }}</mat-option>
                </ng-container>
              </mat-select>
              <mat-error *ngIf="form.get('role').hasError('required')">
                Role is <strong>required</strong>
              </mat-error>
            </mat-form-field>
          </article>
          <article fxLayout fxLayoutAlign="space-between start" fxLayout.lt-md="column" fxLayoutGap="24px">
            <mat-form-field appearance="outline">
              <mat-label>Email Address</mat-label>
              <input matInput type="email" placeholder="E-mail address" formControlName="email" required test-id="demo-email"/>
              <mat-error *ngIf="form.get('email').hasError('required')">
                Email is <strong>required</strong>
              </mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline">
              <tel-input [form]="form.get('phoneNumber')" placeholder="Phone Number" test-id="phone"></tel-input>
            </mat-form-field> 
          </article>
          <article fxLayout="row" fxLayoutAlign="center center">
            <mat-checkbox formControlName="newsletters" test-id="checkbox-newsletters">Subscribe to our newsletters</mat-checkbox>
          </article>
          <button test-id="submit-demo-request" [disabled]="submitted" fxFlexAlign="center" mat-flat-button color="accent" type="submit">{{ buttonText }}</button>
        </form>
      </ng-template>
    </section>
  </section>

  <!-- Festival landing page - They're talking about us -->
  <ng-content select="landing-detail"></ng-content>

  <!-- Festival and catalog landing pages - Link to other app -->
  <ng-content select="landing-app-link"></ng-content>

  <!-- Footer -->
  <ng-container *ngIf="landingFooterComponent; else footer">
    <ng-content select="landing-footer"></ng-content>
  </ng-container>
  <ng-template #footer>
    <footer>
      <section class="max-width" fxLayout="column" fxLayoutAlign="start center" fxLayoutAlign.lt-md="center center"
        fxLayoutGap="32px">
        <div class="footer-form">
          <button app-logo (click)="scrollToTop()"></button>
          <form [formGroup]="newslettersForm" (ngSubmit)="subscribe(newslettersForm)">
            <mat-form-field appearance="outline" hideRequiredMarker>
              <mat-label>Enter your email address</mat-label>
              <input test-id="email" matInput type="email" placeholder="Email address" formControlName="email" required />
              <mat-hint class="mat-caption">Subscribe to our newsletter now!</mat-hint>
              <mat-error *ngIf="form.get('email').hasError('required')">
                Email is <strong>required</strong>
              </mat-error>
            </mat-form-field>
            <button id="newsletterButton" [disabled]="newslettersSubmitted" mat-flat-button color="accent" type="submit">Subscribe</button>
          </form>
        </div>

        <mat-divider></mat-divider>
        <div fxLayout fxLayoutAlign="space-between" fxLayout.lt-md="column" fxLayoutGap="56px">
          <article fxLayout="column" fxLayoutAlign="space-between start">
            <p class="mat-subtitle-2">Proudly associated with the following partners</p>
            <span fxLayout="row wrap" fxLayoutAlign="start">
              <a href="https://www.bpifrance.fr/" target="_blank" ref="noreferrer">
                <img asset="BPI_france.png" type="logo" alt="BPI France logo"/>
              </a>
              <a href="https://ec.europa.eu/culture/funding-creative-europe/creative-europe-media-strand" target="_blank" ref="noreferrer">
                <img asset="creative_media_europe.png" type="logo" alt="creative media europe logo" />
              </a>
              <a href="http://www.ifcic.fr/" target="_blank" ref="noreferrer">
                <img asset="IFCIC_logo.png" type="logo" alt="ifcic">
              </a>
              <a href="https://www.cnc.fr/" target="_blank" ref="noreferrer">
                <img asset="CNC_logo.png" type="logo" alt="cnc">
              </a>
            </span>
          </article>
          <article fxLayout="column" fxLayoutAlign="start start">
            <p>Powered by</p>
            <a href="https://cascade8.com/" target="_blank">
              <img asset="cascade8.svg" type="logo" alt="cascade8">
            </a>
        </article>
          <article fxLayout="column" fxLayoutAlign="start start">
            <p>Follow us</p>
            <span fxLayout fxLayoutGap="24px" fxLayoutGap.lt-lg="8px">
              <a href="https://twitter.com/cascade8_apps?lang=en" target="_blank">
                <img asset="twitter.svg" type="logo" alt="twitter">
              </a>
              <a href="https://www.linkedin.com/company/cascade8/" target="_blank">
                <img asset="linkedin.svg" type="logo" alt="linkedin" />
              </a>
              <a href="https://www.instagram.com/cascade8_apps/" target="_blank">
                <img asset="instagram.svg" type="logo" alt="instagram" />
              </a>
              <a href="https://www.facebook.com/Cascade8" target="_blank">
                <img asset="facebook.svg" type="logo" alt="facebook">
              </a>
            </span>
          </article>
        </div>
      </section>
    </footer>
  </ng-template>

</main>

